import React from "react";
import styles from "./Sidebar.module.css";


export default function SidebarMenu({
  menuOpen,
  toggleMenu,
  navigate,
  handleSignOut
}) {
  return (
    <div className={`${styles.sidebar} ${menuOpen ? styles.open : ""}`}>
      <button className={styles.closeBtn} onClick={toggleMenu}>×</button>

      <ul className={styles.menuList}>
        <li onClick={() => { toggleMenu(); navigate("/how-it-works"); }}>
          How It Works
        </li>

        <li onClick={() => { toggleMenu(); navigate("/about-us"); }}>
          About Us
        </li>

        <li onClick={() => { toggleMenu(); navigate("/contact-us"); }}>
          Contact Us
        </li>

        <li onClick={() => { toggleMenu(); handleSignOut(); }}>
          Logout
        </li>
      </ul>
    </div>
  );
}
